import { render, staticRenderFns } from "./PopperJS.vue?vue&type=template&id=ec9603b4&"
import script from "./PopperJS.vue?vue&type=script&lang=js&"
export * from "./PopperJS.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./PopperJS.vue?vue&type=style&index=0&id=ec9603b4&prod&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports